import { Timestamp } from "firebase/firestore";
import serializable, { propretyCustomSerializable } from "../common/decorators/serializable";
import { EntityFirebase } from "../common/entity.firebase";
import moment, { Moment } from "moment";

export type CashMovementType = "entry" | "withdrawal";

/** Representa uma entrada ou retirada manual no caixa durante uma sessão aberta. */
@serializable
export class CashMovement extends EntityFirebase {
  @propretyCustomSerializable((value: Moment) => Timestamp.fromDate(value.toDate()))
  private createdAt: Moment;

  constructor(
    public readonly id: string,
    private sessionId: string,
    private type: CashMovementType,
    private amount: number,
    private reason: string,
    /** ID da categoria de retirada (null para entradas ou retirada sem categoria). */
    private categoryId: string | null,
    /** Label da categoria no momento do registro (desnormalizado). */
    private categoryLabel: string | null,
    /** ID da conta a pagar vinculada (apenas quando categoryId === "pay_bill"). */
    private payableBillId: string | null,
    private createdByUserId: string,
    createdAt: Moment
  ) {
    super();
    this.createdAt = createdAt;
  }

  getSessionId() { return this.sessionId; }
  getType() { return this.type; }
  getAmount() { return this.amount; }
  getReason() { return this.reason; }
  getCategoryId() { return this.categoryId; }
  getCategoryLabel() { return this.categoryLabel; }
  getPayableBillId() { return this.payableBillId; }
  getCreatedByUserId() { return this.createdByUserId; }
  getCreatedAt() { return this.createdAt; }

  static async build(id: string, data: Record<string, unknown>) {
    const createdRaw = data.createdAt as { toDate?: () => Date } | undefined;
    const type: CashMovementType =
      data.type === "withdrawal" ? "withdrawal" : "entry";
    return new this(
      id,
      typeof data.sessionId === "string" ? data.sessionId : "",
      type,
      typeof data.amount === "number" ? data.amount : 0,
      typeof data.reason === "string" ? data.reason : "",
      typeof data.categoryId === "string" ? data.categoryId : null,
      typeof data.categoryLabel === "string" ? data.categoryLabel : null,
      typeof data.payableBillId === "string" ? data.payableBillId : null,
      typeof data.createdByUserId === "string" ? data.createdByUserId : "",
      createdRaw?.toDate ? moment(createdRaw.toDate()) : moment()
    );
  }
}
